import React, { FormEvent, useCallback } from 'react';

interface JsSubmitFormProps {
    cls: string;
    children: React.ReactNode;
    onKeyDown?: (e: React.KeyboardEvent<HTMLElement>) => void;
}

export const JsSubmitForm = ({ children, cls, onKeyDown }: JsSubmitFormProps) => {
    const onSubmit = useCallback((e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
    }, []);

    return (
        <form onSubmit={onSubmit} className={cls} onKeyDown={onKeyDown}>
            {children}
        </form>
    );
};
